"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("./utils");

var _AdsPlaceholder = _interopRequireDefault(require("../AdsPlaceholder"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable dot-notation */

/* eslint-disable no-unused-expressions */


var GoogleAds = function GoogleAds(_ref) {
  var adsId = _ref.adsId,
      slot = _ref.slot,
      specificPageSize = _ref.specificPageSize,
      theme = _ref.theme,
      viewport = _ref.viewport;

  var AdsStyle = _styledComponents.default.div.withConfig({
    displayName: "GoogleAds__AdsStyle",
    componentId: "sc-720u06-0"
  })(["padding-bottom:0px;"]);

  var returnAdHandler = function returnAdHandler() {
    window['googletag'].cmd.push(function () {
      window['googletag'].display(adsId);
    });
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined' && window['googletag'] && window['googletag'].cmd !== 'undefined') {
      var _window;

      if (typeof ((_window = window) === null || _window === void 0 || (_window = _window.googletag) === null || _window === void 0 ? void 0 : _window.destroySlots) === 'function') {
        var _window2, _window3;

        (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.googletag) === null || _window2 === void 0 || _window2.destroySlots((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.googletag) === null || _window3 === void 0 || (_window3 = _window3.pubads()) === null || _window3 === void 0 || (_window3 = _window3.getSlots()) === null || _window3 === void 0 ? void 0 : _window3.filter(function (availableSlot) {
          return (availableSlot === null || availableSlot === void 0 ? void 0 : availableSlot.getSlotElementId()) === adsId;
        }));
      }
    }

    (0, _utils.addGoogleServiceTagScript)().then(function () {
      (0, _utils.addGoogleAdsScript)(adsId, slot, specificPageSize);
      returnAdHandler();
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(AdsStyle, null, /*#__PURE__*/_react.default.createElement("div", {
    id: adsId
  }, /*#__PURE__*/_react.default.createElement(_AdsPlaceholder.default, {
    theme: theme,
    viewport: viewport,
    type: "standard",
    adsToDisplay: 0,
    customProperties: {
      id: 'Hotels-lob-ads'
    }
  })));
};

GoogleAds.propTypes = {
  adsId: _propTypes.string,
  slot: _propTypes.string,
  specificPageSize: _propTypes.string,
  theme: _propTypes.string,
  viewport: _propTypes.string
};
GoogleAds.defaultProps = {
  adsId: '',
  slot: '',
  specificPageSize: '',
  viewport: 'desktop',
  theme: ''
};

var _default = /*#__PURE__*/_react.default.memo(GoogleAds);

exports.default = _default;